import service from "../../util/http";

// 查询流程表单列表
export function listForm(query) {
  return service({
    url: '/manage/flowable/form/list',
    method: 'get',
    params: query
  })
}
export function listAllForm(query) {
  return service({
    url: '/manage/flowable/form/formList',
    method: 'get',
    params: query
  })
}

// 查询流程表单详细
export function getForm(formId) {
  return service({
    url: '/manage/flowable/form/' + formId,
    method: 'get'
  })
}

// 新增流程表单
export function addForm(data) {
  return service({
    url: '/manage/flowable/form',
    method: 'post',
    data: data
  })
}

// 修改流程表单
export function updateForm(data) {
  return service({
    url: '/manage/flowable/form',
    method: 'put',
    data: data
  })
}
// 挂载表单
export function addDeployForm(data) {
  return service({
    url: '/manage/flowable/form/addDeployForm',
    method: 'post',
    data: data
  })
}

// 删除流程表单
export function delForm(formId) {
  return service({
    url: '/manage/flowable/form/' + formId,
    method: 'delete'
  })
}

// 导出流程表单
export function exportForm(query) {
  return service({
    url: '/manage/flowable/form/export',
    method: 'get',
    params: query
  })
}
